module.exports = __webpack_public_path__ + "static/img/in_review.6d37e4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/in_review.png
// module id = y3dD
// module chunks = 2